import { DateTime } from "luxon";

import type { ChatThread } from "types";
import { sortThreadsByDate } from "./sortThreadsByDate";

export type GroupedChats = [string, ChatThread[]][];

const getDateGrouping = (timestamp: string) => {
  const date = DateTime.fromISO(timestamp);
  const now = DateTime.now();

  if (date.hasSame(now, "day")) return "Today";
  if (date.hasSame(now.minus({ days: 1 }), "day")) return "Yesterday";
  if (date > now.minus({ days: 7 })) return "Previous 7 Days";
  if (date > now.minus({ days: 30 })) return "Previous 30 Days";
  if (date.year === now.year) return date.toFormat("MMMM");

  return `${date.year}`;
};

export function groupThreadsByDate(chatThreads: ChatThread[]): GroupedChats {
  const sortedThreads = sortThreadsByDate(chatThreads);

  const groups: GroupedChats = [];
  sortedThreads.forEach((thread) => {
    const group = getDateGrouping(thread.timestamp);
    const existingGroup = groups.find(([groupName]) => groupName === group);
    if (existingGroup) {
      existingGroup[1].push(thread);
    } else {
      groups.push([group, [thread]]);
    }
  });

  return groups;
}
